<template>
    <el-input
        :parser="(value) => {return parser(value)}"
        :formatter="(value) => {return formatter(value)}"
        v-model="model"
        @focus="onFocus"
        @blur="onBlur"
        ref="input"
    >
    </el-input>
</template>

<script setup>
import { nextTick, ref,onMounted,reactive,defineProps,watch} from 'vue';
const props = defineProps(['model','prefix'])
const input = ref(null);
var mounted = false;
var defaultValueUpdate = false;
var dollarPrefix = '$ ';
function formatter(value){
    return `${dollarPrefix}${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
function parser(value){
    return value.replace(/[^0-9.]/g, '').replace(/\$\s?|(,*)/g, '').replace(/^(\d+.?\d{0,2})\d*$/, "$1")
}
function onFocus(){
    if(input.value.input.value==dollarPrefix+'0' || input.value.input.value == 0){
        input.value.input.value = dollarPrefix;
    }   
}
function onBlur(){
    if(input.value.input.value==dollarPrefix || input.value.input.value == 0){
        input.value.input.value = dollarPrefix+'0';
    }
}
function updateValue(){
    if(!defaultValueUpdate){
        input.value.input.value = parser(input.value.input.value);
        input.value.input.value = formatter(input.value.input.value);
        defaultValueUpdate = true;
    }
}
onMounted(() => {
    //props.model += 1;
    input.value.input.value = parser(input.value.input.value);
    input.value.input.value = formatter(input.value.input.value);
    mounted = true;
    if(props.prefix){
        dollarPrefix = props.prefix;
    }
    //input.value.input.emit('input', input.value.input.value)
    nextTick();
});
watch(
    () => props.model,
    (value, oldValue) => {
        if(mounted){
            setTimeout(function(){
                updateValue();
            },1)
        }
       //updateValue();
       //input.value.input.value = 1;
       //input.value.input.value = parser(input.value.input.value);
       //input.value.input.value = formatter(input.value.input.value);
    }, {immediate:true}
)
</script>